export const STAT_RING_SUBLABEL_SEPARATOR = ' · ';

// Parts of a "0 go · 4 no-go/gb" style sublabel, so a narrow ring wraps between them, never inside.
export function splitStatRingSublabel(sublabel: string): string[] {
    return sublabel
        .split(STAT_RING_SUBLABEL_SEPARATOR)
        .map((part) => part.trim())
        .filter((part) => part.length > 0);
}
